import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TermsContentComponent } from '../terms-content/terms-content.component';
import { PrivacyContentComponent } from '../privacy-content/privacy-content.component';

@Component({
    selector: 'app-terms',
    standalone: true,
    imports: [CommonModule, TermsContentComponent, PrivacyContentComponent],
    templateUrl: './terms.component.html',
    styleUrl: './terms.component.css'
})
export class TermsComponent {
    activeTab: 'terms' | 'privacy' = 'terms';

    setActiveTab(tab: 'terms' | 'privacy') {
        this.activeTab = tab;
        // Scroll to top when switching tabs
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}
